import React, { useEffect, useState } from 'react';
import Lottie from "lottie-react";
import img from '../../assets/banner-right.svg';  
import animationData from '../../assets/transparent lottie.json'; 


const Banner = () => {
    return (
        <div>
            <div className="header-section">
                <div className="container container-header">
                    <div className="row">
                        <div className="col-12">
                            <h4 className="header-span">Test. Treat. Swim.</h4>
                            <h1 className="banner-head">Crystal-Clear Pools – Free 10-Day Trial!</h1>
                            <div>
                                <ul className="banner-ul d-flex justify-content-center p-0 flex-wrap">
                                    <li>
                                        <div><img src={img} alt="Instant Safe to Swim Alerts" /></div>
                                        Instant “Safe to Swim” Alerts
                                    </li>
                                    <li>
                                        <div><img src={img} alt="Exact Dosages" /></div>
                                        Exact Dosages
                                    </li>
                                    <li>
                                       <div> <img src={img} alt="24/7 HelpBot" /></div>
                                        24/7 HelpBot
                                    </li>
                                </ul>
                            </div>
                            <div className="text-center">
                                <button className="btn btn-start landing-slider-button">Start Free Trial</button>
                            </div>
                        </div>
                    </div>
                </div>
                <br /><br />
               {/* <div className='animate-video text-center'>
               
                <img src={img1} alt="" className='img-fluid img-banner-gif' />
               </div> */}
               {animationData && (
                    <Lottie animationData={animationData} loop={true} className="lottie-banner" />
                )}
           
            </div>
        </div>
    );
};

export default Banner;